/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react'
import { useContext } from 'react'
import { useParams, useLocation } from 'react-router-dom'
import isEmpty from 'lodash/isEmpty'
import {
  getPeriodicalReportMarkingById,
  updatePeriodicalReportMarkingById
} from '../../../../../../services/periodical-report/periodical-report-marking.service'
import {
  updatePeriodicalReportMarkingStudents,
  updatePeriodicalReportMarkingMode,
  updatePeriodicalReportMarkingStudent
} from '../../../../../../store/actions/periodical-report.actions'
import { useDispatch, useSelector } from 'react-redux'
import { handlerErrorV2 } from '../../../../../../utils/errors'
import usePeriodicalReport from '../../../../../../hooks/periodical-report/usePeriodicalReport'
import { toggleAlertModule } from '../../../../../../store/actions/alert.actions'
import { getPeriodicalReportClassesById } from '../../../../../../services/periodical-report/periodical-report-classes.service'
import { getCurriculum } from '../../../../../../services/curriculum/curriculum.service'
import { getSettingSubModule } from '../../../../../../services/periodical-report/periodical-report-setting.service'
import MarkingUtils from '../../../../../../utils/marking.utils'

const MarkingContextContext = React.createContext()

export const MarkingContextProvider = ({ children }) => {
  const { periodicalReportId } = useParams()
  const dispatch = useDispatch()
  const history = useLocation()
  const [loading, setLoading] = useState(true)
  const [loadingSave, setLoadingSave] = useState(false)
  const [filter, setFilter] = useState({})
  const permissions = useSelector((state) => state?.session?.permissions?.['periodical-report-marking'] || {})

  const mode = useSelector((state) => state?.periodicalReport?.mode || {})
  const [specialCircumstances, setSpecialCircumstances] = useState([])
  const [ratings, setRating] = useState([])
  const [effortAndConductOptions, setEffortAndConduct] = useState([])

  const [markingStudents, setMarkingStudents] = useState([])
  const [previousPeriodicalReport, setPreviousPeriodicalReport] = useState({})
  const [error, setError] = useState(null)
  const [currentAssessmentArea, setCurrentAssessmentArea] = useState(null)

  const [permission, setPermission] = useState(false)

  const [idla, setIdla] = useState(null)
  const [idYear, setIdYear] = useState(null)

  const [listClasses, setListClasses] = useState([])
  const [loadingClasses, setLoadingClasses] = useState(false)

  const [curriculumList, setCurriculumList] = useState([])

  const [selector, toggleSelector] = useState(
    window.location.pathname === `/dashboard/periodical-report/marking/${periodicalReportId}`
      ? 'filter-by-learning-area-and-year-level'
      : 'filter-by-classes'
  )

  const onFilter = (filter) => {
    setFilter((old) => ({ ...old, ...filter }))
  }
  const { getPeriodicalReportById } = usePeriodicalReport()

  const onLoadSpecialCircumstances = useCallback(async () => {
    try {
      const response = await getSettingSubModule('special-circumstances')
      if (response.error) {
        console.error(response.error.message || 'An error ocurred')
      } else {
        setSpecialCircumstances(response.data || [])
      }
    } catch (error) {
      const message = handlerErrorV2(error)
      console.error(message)
    }
  }, [])

  useEffect(() => {
    onLoadSpecialCircumstances()
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getCurriculum(true)
        if (!response?.data && response?.error) {
          console.error(response.error.message || 'An error ocurred')
        } else {
          setCurriculumList(response?.data || null)
        }
      } catch (error) {
        const message = handlerErrorV2(error)
        console.error(message)
      }
    }
    fetchData()
  }, [])

  const [errorCurrent, setErrorCurrent] = useState(null)
  const [isLoading, toggleLoading] = useState(false)
  const [currentPeriodicalReport, setCurrentPeriodicalReport] = useState({})

  const onLoadCurrent = useCallback(async () => {
    if (periodicalReportId) {
      toggleLoading(true)
      try {
        const response = await getPeriodicalReportById(periodicalReportId)
        if (response?.error) {
          setErrorCurrent({
            message: response.error.message || 'An error ocurred'
          })
        } else {
          const formData = response?.data || {}
          setCurrentPeriodicalReport(formData)
          setRating(formData.ratings || [])
          setEffortAndConduct(formData.effortAndConductOptions)
          if (formData.previousPeriodicalReportId) {
            setPreviousPeriodicalReport(formData.previousPeriodicalReportId || {})
          }
        }
      } catch (error) {
        const message = handlerErrorV2(error)
        setErrorCurrent(message)
      } finally {
        toggleLoading(false)
      }
    }
  }, [periodicalReportId])

  const onUpdateMarkingStudent = (student, field = 'level', data) => {
    let rating = null
    if (field === 'level' && data.assessmentAreaRatingType === 'age-expected-scale') {
      const studentYearLevel = markingStudents.find((item) => item.studentId === student.studentId)?.yearLevel
      const ratings = data.ratings.filter((option) => option?.type === data.assessmentAreaRatingType)
      const dataRating = MarkingUtils.calculateRating(ratings, data.level, studentYearLevel)
      rating = dataRating
        ? {
            _id: dataRating._id,
            code: dataRating.code,
            name: dataRating.name,
            scaleAE: dataRating.scaleAE
          }
        : null
      student.rating = rating
    }
    dispatch(updatePeriodicalReportMarkingStudent(student))
    setMarkingStudents((markingStudents) =>
      markingStudents.map((item) => {
        if (item.studentId === student.studentId) {
          const marking = item.marking.map((mark) => {
            if (
              mark.elementId === student.elementId &&
              mark.subElementId === student.subElementId &&
              mark.assessmentAreaId === student.assessmentAreaId
            ) {
              if (field === 'level' && data.assessmentAreaRatingType === 'age-expected-scale') {
                mark.rating = rating
              }
              return {
                ...mark,
                [field]: student[field]
              }
            } else {
              return mark
            }
          })
          return {
            ...item,
            marking
          }
        } else {
          return item
        }
      })
    )
  }

  useEffect(() => {
    onLoadCurrent()
  }, [onLoadCurrent])

  const learningAreas = useSelector((state) => state?.periodicalReport?.learningAreas || [])
  const yearLevels = useSelector((state) => state?.periodicalReport?.yearLevels || [])

  useEffect(() => {
    if (learningAreas) {
      let id = null
      const area = learningAreas?.find((item) => item.name === 'English')
      if (area) {
        id = area._id
      } else {
        id = learningAreas[0]?._id
      }
      setIdla(id)
    }
  }, [learningAreas])

  useEffect(() => {
    if (yearLevels) {
      setIdYear(yearLevels[0]?._id)
    }
  }, [yearLevels])

  useEffect(() => {
    if (selector === 'filter-by-classes') {
      const newFilter = filter
      newFilter.learningArea = null
      newFilter.yearLevel = null

      setFilter({ ...newFilter, ...history?.state?.filter })
    } else {
      const newFilter = filter
      if (permissions?.marking?.includes('bulk')) {
        newFilter.learningArea = idla
        newFilter.yearLevel = idYear
        newFilter.classId = null
        newFilter.classCode = null
      }
      setFilter({ ...newFilter, ...history?.state?.filter })
    }
    dispatch(updatePeriodicalReportMarkingStudents([]))
  }, [selector, idla, idYear])

  const onLoad = useCallback(async () => {
    try {
      setMarkingStudents([])
      if (!selector) {
        return
      }

      if (isEmpty(filter)) {
        return
      }

      if (selector === 'filter-by-learning-area-and-year-level') {
        if (!filter?.learningArea) {
          return
        }
        if (!filter?.yearLevel) {
          return
        }
      } else {
        if (!filter?.classId) {
          return
        }
      }

      setError(null)
      setLoading(true)
      const filterData = {
        elementId: filter?.learningArea,
        subElementId: filter?.subElementId,
        yearLevelId: filter?.yearLevel,
        classId: filter?.classId,
        isEmpty: filter?.isEmpty
      }
      const response = await getPeriodicalReportMarkingById(periodicalReportId, filterData)
      if (!response.data && response.error) {
        setError(response.error.message || 'An error ocurred')
      } else {
        if (response.data.total === 0) {
          setError('Data not generated')
        } else {
          setMarkingStudents(response?.data || [])
        }
      }
    } catch (error) {
      const message = handlerErrorV2(error)
      setError(message)
    } finally {
      setLoading(false)
    }
  }, [filter, periodicalReportId, selector])

  useEffect(() => {
    onLoad()
  }, [onLoad])

  const updatePeriodicalReportMarking = async (students) => {
    try {
      setLoadingSave(true)
      dispatch(
        updatePeriodicalReportMarkingMode({
          ...mode,
          text: 'saving'
        })
      )
      const response = await updatePeriodicalReportMarkingById(periodicalReportId, { students })
      if (response.error) {
        dispatch(
          updatePeriodicalReportMarkingMode({
            ...mode,
            text: 'error',
            error: response.error.message || 'An error ocurred'
          })
        )
      } else {
        dispatch(updatePeriodicalReportMarkingStudents([]))
        dispatch(toggleAlertModule())
      }
    } catch (error) {
      dispatch(
        updatePeriodicalReportMarkingMode({
          ...mode,
          text: 'error',
          error: handlerErrorV2(error)
        })
      )
    } finally {
      setLoadingSave(false)
    }
  }

  useEffect(() => {
    if (currentPeriodicalReport) {
      let result = false

      if (currentPeriodicalReport.isCurrent) {
        if (currentPeriodicalReport.status === 'open-for-marking') {
          result = !!permissions?.marking
        } else if (currentPeriodicalReport.status === 'open-for-review') {
          result = !!permissions?.['review-data']
        }
      }

      setPermission(result)
    }
  }, [currentPeriodicalReport, permissions])

  const onLoadClasses = useCallback(async () => {
    try {
      setLoadingClasses(true)
      const response = await getPeriodicalReportClassesById(periodicalReportId)
      if (!response.data && response.error) {
        setError(response.error.message || 'An error ocurred')
      } else {
        setListClasses(response?.data || [])
      }
    } catch (error) {
      const message = handlerErrorV2(error)
      setError(message)
    } finally {
      setLoadingClasses(false)
    }
  }, [periodicalReportId])

  useEffect(() => {
    onLoadClasses()
  }, [])

  return (
    <MarkingContextContext.Provider
      value={{
        currentPeriodicalReport,
        previousPeriodicalReport,
        errorCurrent,

        permission,

        isLoading,
        toggleSelector,
        selector,

        onFilter,
        filter,

        loading,

        markingStudents,
        error,

        loadingSave,
        updatePeriodicalReportMarking,
        onUpdateMarkingStudent,

        loadingClasses,
        listClasses,
        curriculumList,
        specialCircumstances,
        ratings,
        effortAndConductOptions,

        currentAssessmentArea,
        setCurrentAssessmentArea
      }}
    >
      {children}
    </MarkingContextContext.Provider>
  )
}

export const useMarkingContext = () => {
  const context = useContext(MarkingContextContext)
  if (context === undefined) {
    throw new Error('useMarkingContext must be used within a MarkingContextProvider')
  }
  return context
}
